import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_MDC_STOCK_POSTING_SCAN_STOCK } from '../mdc-stock-posting.api';
import { Stock } from '../types/stock';

@Injectable()
export class StockRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  scan(code: string): Promise<Stock> {
    return this.dataAccess.get<Stock>({
      path: SOFTLINE_API_MDC_STOCK_POSTING_SCAN_STOCK,
      pathParams: { code },
    });
  }
}
